'use strict';

import React from 'react';

import ConditionalDisplay from 'components/utils/ConditionalDisplay';
import classNames from 'classnames';
import utils from 'services/utils';

import 'styles/ApprovalStatusActionControls.scss';
import _ from 'underscore';
import appConstants from 'constants/appConstants';
import approvalsStore from 'stores/ApprovalsStore';
import approvalsActions from 'actions/ApprovalsActionCreators';

import 'styles/Salvatrix.scss';

import moment from 'moment';

const propTypes = {};

const defaultProps = {};

class Salvatrix extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {

        var person = this.props.userInfo && this.props.userInfo.person || null;
        var tasks = this.props.approvalsData;

        if (!person) {
            return <span />;
        }

        var name = person.PreferredName || person.FirstName;

        var say = "Hello " + name + ".";
        
        // Day awareness
        var hourOfDay = parseInt(moment().format('HHmm'),10); 
        
        if (hourOfDay > 1100 && hourOfDay < 200) {
            say = "Hey " + name + ". Burning the midnight oil.";
        } else if (hourOfDay > 200 && hourOfDay <= 400) {
            say = "Gooooood moooorning, " + name + " !";
        } else if (hourOfDay > 400 && hourOfDay <= 600) {
            say = "Gooooood moooorning, " + name + " !";
        } else if (hourOfDay > 600 && hourOfDay <= 900) {
            say = "Good morning " + name + ".";
        } else if (hourOfDay > 900 && hourOfDay <= 1030) {
            say = "Good morning " + name + ".";
        } else if (hourOfDay > 1030 && hourOfDay <= 1200) {
            say = "Good morning " + name + ".";
        } else if (hourOfDay > 1200 && hourOfDay <= 1230) {
            say = "Good afternoon " + name + "."; 
        } else if (hourOfDay > 1230 && hourOfDay <= 1400) {
            say = "Good afternoon " + name + "."; 
        } else if (hourOfDay > 1400 && hourOfDay <= 1430) {
            say = "Good afternoon " + name + ".";
        } else if (hourOfDay > 1430 && hourOfDay <= 1500) {
            say = "Good afternoon " + name + ".";
        } else if (hourOfDay > 1500 && hourOfDay <= 1600) {
            say = "Good afternoon " + name + ".";
        } else if (hourOfDay > 1600 && hourOfDay <= 1700 ) {
            say = "Good afternoon " + name + ".";
        } else if (hourOfDay > 1700 && hourOfDay <= 1900) {
            say = "Good evening " + name + ".";
        } else if (hourOfDay > 1900 && hourOfDay <= 2200) {
            say = "Good evening " + name + ".";
        } 

        // First time
        if (!person.LastLogin) {
            say = "Welcome " + name + "!";
        }

        // Leave 

        // Tasks
        if (tasks) {
            var numOfLeaveChanges = _.filter(tasks.approvals, {WorkflowType: appConstants.ENUMS.WORKFLOW_TYPES.LEAVE}).length;
            var numOfPersonalChanges = _.filter(tasks.approvals, {WorkflowType: appConstants.ENUMS.WORKFLOW_TYPES.PERSONAL_CHANGES}).length;

            if (numOfPersonalChanges  > 0 && numOfPersonalChanges > numOfLeaveChanges) {
                if (numOfPersonalChanges > 3) {
                    say = "Hey " + name + ", there are several profile changes to approve.";
                } else if (numOfPersonalChanges > 1) {
                    say = "Hey " + name + ", there are a few profile changes to approve.";
                } else {
                    say = "Hey " + name + ", a profile change requires your approval.";
                }
            } else if (numOfLeaveChanges > 0) {
                if (numOfLeaveChanges > 3) {
                    say = "Hey " + name + ", there are several leave applications to approve.";
                } else if (numOfLeaveChanges > 1) {
                    say = "Hey " + name + ", there are a few leave applications to approve.";
                } else {
                    say = "Hey " + name + ", a leave application requires your approval.";
                }
            }
        }
        
        return (
            <div className="salvatrix">
                {say}
            </div>
        );
    }
}

Salvatrix.propTypes = propTypes;
Salvatrix.defaultProps = defaultProps;

export default Salvatrix; 